class MainNavigation {
  constructor() {

    function setAnchorOffset() {
      headerHeight = document.querySelector('.page-wrapper header').offsetHeight;
      document.getElementsByTagName('html')[0].style = 'scroll-padding-top:' + headerHeight + 'px';
    }

    setAnchorOffset();

    document.addEventListener('click', (e) => {
      if (e.id != 'main-navigation' && e.srcElement.closest('#main-navigation') == null) {
        $('#main-navigation .collapse.show').collapse('hide');
      }
      if (e.srcElement.className.indexOf('navbar-toggler') >= 0 || e.srcElement.closest('.navbar-toggler') != null) {
        if ($('header.navOpen').length > 0) {
          $('header').removeClass('navOpen');
        } else {
          $('header').addClass('navOpen');
        } 
      }
    });

    document.querySelector('.page-wrapper header').addEventListener('change', (e) => {
      setAnchorOffset();
    });

    document.addEventListener('resize', (e) => {
      setAnchorOffset();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MainNavigation();
})
